import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'referral',
    viewPath: props.viewPath,
  })

  return () => {
    change(next => {
      next.person = undefined
    })
  }
}
